import { render, staticRenderFns } from "./RateHeaderDetail.vue?vue&type=template&id=8a27cfc8&scoped=true&"
import script from "./RateHeaderDetail.vue?vue&type=script&lang=js&"
export * from "./RateHeaderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a27cfc8",
  null
  
)

export default component.exports